@for (input of inputs(); track input.id) {
    <div
        class="node-input-connector"
        fNodeInput
        [fInputId]="input.id"
        fInputConnectableSide="left"
        [isSelfConnectable]="false"></div>
}
